/* N2 Collection — テーマの JS。
   原則: 無くても買えること。ここでやっているのは、手数を減らすことだけ。
   （書類のような見た目にしているので、動きで飾ることはしない） */
(function () {
  "use strict";

  /* 絞り込み: チェックした時点で送る。「絞り込む」を押させると1手増える。
     JS が無い環境では noscript の送信ボタンが出るので、機能自体は失われない。 */
  var form = document.getElementById("filter-form");
  if (form) {
    form.addEventListener("change", function () { form.submit(); });
  }

  /* 並べ替えは絞り込みフォームの外にあるが、送信は同じフォームに乗せる
     （別々に送ると、片方の条件が消える） */
  var sort = document.querySelector("[data-sort]");
  if (sort && form) {
    sort.addEventListener("change", function () {
      var hidden = form.querySelector('input[name="sort_by"]');
      if (!hidden) {
        hidden = document.createElement("input");
        hidden.type = "hidden";
        hidden.name = "sort_by";
        form.appendChild(hidden);
      }
      hidden.value = sort.value;
      form.submit();
    });
  }

  /* 絞り込みの開閉: 広い画面では常に開く。狭い画面では畳む。
     開いたまま置くと、商品が2画面ぶん下に押し出される。 */
  var box = document.getElementById("filters");
  if (box) {
    var wide = window.matchMedia("(min-width: 60em)");
    var apply = function () { box.open = wide.matches; };
    apply();
    wide.addEventListener("change", apply);
  }

  /* バリアントの選択: 選択肢の組み合わせから該当バリアントを選ぶ。
     選択肢が1つ（既定バリアントのみ）の商品では何もしない。 */
  var variantSelect = document.querySelector("[data-variant-select]");
  var optionSelects = document.querySelectorAll("[data-variant-option]");
  if (variantSelect && optionSelects.length) {
    var sync = function () {
      var chosen = [];
      optionSelects.forEach(function (el) { chosen.push(el.value); });
      var want = chosen.join(" / ");
      for (var i = 0; i < variantSelect.options.length; i++) {
        if (variantSelect.options[i].text.trim() === want) {
          variantSelect.selectedIndex = i;
          return;
        }
      }
    };
    optionSelects.forEach(function (el) { el.addEventListener("change", sync); });
  }
})();
